


































































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ssmPermissionService } from "@/shared/services/PermissionService";
import LayoutMenuModule from "@/store/modules/layout-menu-module";
import { MenuItem } from "../Menu/menu-item";
import { UtilsString } from "@/utils/utils-string";
import { RouterNames } from "@/router/routernames";
import menu_optionModule from "@/store/modules/menu_option-module";
import VersionBackModule from "@/store/modules/VersionBack-module";
import VersionChecker from "@/shared/services/version-checker";

@Component({
  components: {
    ModernMenuOption: () => import("./option/menu-option.vue"),
    ModernMenuGroup: () => import("./group/menu-group.vue"),
  },
})
export default class MenuRoot extends Vue {
  @Prop({ default: [] }) public fullMenuOptions!: MenuItem[];
  public appTitle = process.env.VUE_APP_TITLE || "Dashboard";
  public appSubtitle = process.env.VUE_APP_SUBTITLE || "Panel de Control";
  public nextCheckStr = "";
  public showVersionData = false;
  private tickerId: any = null;

  private menu: MenuItem[] = [];

  public get drawer(): boolean {
    return LayoutMenuModule.visible;
  }

  public get menuStyle() {
    return {
      height: `${this.menuHeight}px`,
      overflowX: "hidden",
      overflowY: "auto",
      paddingBottom: "20px",
    };
  }

  public get menuHeight() {
    return this.$vuetify.breakpoint.height - 250;
  }

  public set drawer(newToggle: boolean) {
    LayoutMenuModule.setVisible(newToggle);
  }

  public created() {
    this.createUserMenu();
  }

  public async mounted() {
    // Cargar versión del backend
    try {
      await VersionBackModule.getVersionFront();
    } catch (error) {
      console.error("Error loading backend version:", error);
    }

    // Iniciar ticker para la cuenta regresiva
    this.startTicker();
  }

  public beforeDestroy() {
    if (this.tickerId) {
      clearInterval(this.tickerId);
    }
  }

  private startTicker() {
    this.updateNextCheckStr();
    this.tickerId = setInterval(() => {
      this.updateNextCheckStr();
    }, 1000);
  }

  private updateNextCheckStr() {
    if (!VersionChecker.nextCheckTime) {
      this.nextCheckStr = "";
      return;
    }

    const diff = VersionChecker.nextCheckTime - Date.now();
    if (diff <= 0) {
      this.nextCheckStr = "Verificando...";
      return;
    }

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    this.nextCheckStr = `${minutes}:${seconds.toString().padStart(2, "0")}`;
  }

  public get backendVersion() {
    return VersionBackModule.GetVersionEnv || null;
  }

  public get cacheVersion() {
    // Obtener versión del cache desde localStorage (establecida por version-checker)
    return localStorage.getItem("appVersion") || null;
  }

  public goToHome() {
    this.$router.push({ name: RouterNames.Home });
  }

  private async refresh_menu() {
    // Recargar opciones del menú desde el backend
    await menu_optionModule.getmenu();
    // Reconstruir el menú del usuario con las nuevas opciones
    this.createUserMenu();
  }
  private is_developer() {
    //Mejor si miro si tiene el permiso de menu_menu
    return this.hasPermiso("Permissions.Administradores.Read");
  }

  private createUserMenu() {
    this.menu = [];
    for (const item of this.fullMenuOptions) {
      this.createUserMenuOpcion(item);
    }
  }

  private createUserMenuOpcion(item: MenuItem, parent?: MenuItem) {
    if (this.hasPermiso(item.permission)) {
      const newItem: MenuItem = this.newMenuItem(item);

      if (this.hasSubmenuOptions(item)) {
        for (const child of item.children) {
          this.createUserMenuOpcion(child, newItem);
        }
      }

      this.AddUserMenuOpcion(newItem, parent);
    }
  }

  private AddUserMenuOpcion(newItem: MenuItem, parent?: MenuItem) {
    if (
      !UtilsString.IsNullOrWhiteSpace(newItem.link) ||
      this.hasSubmenuOptions(newItem)
    ) {
      if (parent != null && parent.children != null) {
        parent.children.push(newItem);
      } else {
        this.menu.push(newItem);
      }
    }
  }
  private ordenar_menu() {
    this.$router.push({ name: RouterNames.menu_plataforma_organizar });
  }

  private hasPermiso(permiso: string) {
    const result =
      UtilsString.IsNullOrWhiteSpace(permiso) ||
      ssmPermissionService.hasPermission(permiso);
    return result;
  }

  private hasSubmenuOptions(item: MenuItem): boolean {
    return item.children != null && item.children.length > 0;
  }

  private newMenuItem(item: MenuItem): MenuItem {
    const newItem = new MenuItem();
    newItem.icon = item.icon;
    newItem.text = item.text;
    newItem.link = item.link;
    newItem.color = item.color;
    newItem.icon_fntaws = item.icon_fntaws;
    newItem.permission = item.permission;
    newItem.children = [];
    return newItem;
  }
}
